import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/owlBranding/outlineOwl.webp'

export const OwlOutline: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'outlines'} />
)
